export type Lang = 'en' | 'tr';

/** Desteklenen diller ve görünen adları. */
export const LANGS: { code: Lang; label: string; short: string }[] = [
	{ code: 'en', label: 'English', short: 'EN' },
	{ code: 'tr', label: 'Türkçe', short: 'TR' }
];

export type Dict = Record<string, string>;
